import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-mb-0" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-d-flex p-jc-between" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "is_package" }, "Abilita colli", -1)
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createTextVNode("Consultare "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://fontawesome.com/v5.15/icons?d=gallery&p=2&m=free",
    target: "_blank"
  }, " elenco icone ")
], -1)
const _hoisted_12 = { class: "p-d-flex p-jc-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    visible: _ctx.showModel,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModel = $event)),
    class: "p-fluid",
    style: { width: '450px' },
    modal: true,
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0,
    "dismissable-mask": ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.vehicleModel.id
            ? _ctx.$t('vehicle.detail.edit')
            : _ctx.$t('vehicle.detail.new')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Button, {
          label: _ctx.$t('cancel'),
          icon: "pi pi-times",
          class: "p-button-text p-button-secondary",
          onClick: _ctx.onDialogCancel
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          type: "submit",
          form: "vehicle_form",
          label: _ctx.$t('common.save'),
          icon: "pi pi-check",
          class: "p-button-text"
        }, null, 8, ["label"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        id: "vehicle_form",
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDialogSave && _ctx.onDialogSave(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FloatLabel, { label: "Nome" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                modelValue: _ctx.vehicleModel.name_it,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.vehicleModel.name_it = $event)),
                autofocus: "",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FloatLabel, { label: "Note" }, {
            default: _withCtx(() => [
              _createVNode(_component_Textarea, {
                modelValue: _ctx.vehicleModel.note,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.vehicleModel.note = $event)),
                cols: 35,
                rows: 5
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FloatLabel, { label: "Profondità (cm) " }, {
              default: _withCtx(() => [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.vehicleModel.l1,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vehicleModel.l1 = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_FloatLabel, {
              label: "Larghezza (cm)",
              class: "p-mx-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.vehicleModel.l2,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.vehicleModel.l2 = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_FloatLabel, { label: "Altezza (cm)" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.vehicleModel.l3,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.vehicleModel.l3 = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FloatLabel, { label: "Peso max (Kg)" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.vehicleModel.weight,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.vehicleModel.weight = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Checkbox, {
              id: "is_package",
              modelValue: _ctx.vehicleModel.is_package,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.vehicleModel.is_package = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FloatLabel, { label: "Icona" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                modelValue: _ctx.vehicleModel.icon,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.vehicleModel.icon = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_11
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible"]))
}